import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    QuotaCreate as QuotaCreateMutation,
    QuotaCreateVariables,
} from 'nutshell-graphql-types';

import CREATE_QUOTA from '../mutations/create-quota.graphql';

import {addUsersToConnection, updateYearOverviewStatsCacheFromDuplicatingQuotas} from './helpers';

export type DuplicateQuotaInput = {
    userIds: string[];
    duplicateFromUserId: string;
    fiscalYear?: number;
};

export function useDuplicateQuota(): {
    duplicateQuota: (input: DuplicateQuotaInput) => Promise<any>;
    isLoading: boolean;
    errorMessage: string | null | undefined;
} {
    const [mutate, {loading, error}] = useMutation<QuotaCreateMutation, QuotaCreateVariables>(
        CREATE_QUOTA
    );

    return {
        duplicateQuota: (input: DuplicateQuotaInput) =>
            mutate({
                variables: {input},
                update: (cache, {data}) => {
                    const users = data?.quotaCreate?.users;
                    if (!users?.length) return;
                    updateYearOverviewStatsCacheFromDuplicatingQuotas(
                        cache,
                        input.userIds,
                        input.duplicateFromUserId,
                        input.fiscalYear
                    );
                    addUsersToConnection(cache, users);
                },
            }),
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
}
